<template>
  <div class="userContent">
    <Form ref="userInfoForm" :model="userInfoForm" :rules="ruleuserInfo" label-position="left" :label-width="135"
      inline>
      <FormItem label="工号：" prop="sid">
        <Input v-model="userInfoForm.sid" disabled></Input>
      </FormItem>
      <FormItem label="姓名：" prop="userName">
        <Input v-model="userInfoForm.userName" :disabled="inpDisabled"></Input>
      </FormItem>
      <FormItem label="性别：" prop="userSex">
        <Select v-model="userInfoForm.userSex" disabled>
          <Option value="1">男</Option>
          <Option value="2">女</Option>
        </Select>
      </FormItem>
      <FormItem label="学历：" prop="userEdcation">
        <Select v-model="userInfoForm.userEdcation" placeholder="请选择类型" disabled>
          <Option value="大专及以上">大专及以上</Option>
          <Option value="初、高中（含中专）">初、高中（含中专）</Option>
          <Option value="初中以下">初中以下</Option>
        </Select>
      </FormItem>
      <FormItem label="联系电话：" prop="userTel">
        <Input v-model="userInfoForm.userTel"></Input>
      </FormItem>
      <FormItem label="电子邮箱：" prop="userEmail">
        <Input v-model="userInfoForm.userEmail"></Input>
      </FormItem>
      <FormItem label="当前状态：" prop="userStatus">
        <Select v-model="userInfoForm.userStatus">
          <Option value="1">离退休</Option>
          <Option value="2">在职</Option>
          <Option value="3">自由职业</Option>
        </Select>
      </FormItem>
      <FormItem label="身份证号：" prop="userIdCard">
        <Input v-model="userInfoForm.userIdCard" :maxlength="18" disabled></Input>
      </FormItem>
      <FormItem label="原(工作单位)：" prop="userUnit">
        <Input v-model="userInfoForm.userUnit"></Input>
      </FormItem>
      <FormItem label="家庭地址：" prop="userAdress">
        <Input v-model="userInfoForm.userAdress"></Input>
      </FormItem>
      <FormItem label="紧急联系人姓名：" prop="emergencyContactName">
        <Input v-model="userInfoForm.emergencyContactName"></Input>
      </FormItem>
      <FormItem label="紧急联系人电话：" prop="emergencyContactPhone">
        <Input v-model="userInfoForm.emergencyContactPhone"></Input>
      </FormItem>
      <div class="btn">
        <FormItem>
          <Button class="upData" type="primary" @click="updataSubmit('userInfoForm')">更新基本信息</Button>
        </FormItem>
      </div>
    </Form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfoForm: {
        userIdCard: "",
        userName: "",
        userSex: "",
        userEdcation: "",
        userUnit: "",
        userTel: "",
        userEmail: "",
        userStatus: "",
        userAdress: "",
        emergencyContactName: "",
        emergencyContactPhone: "",
        sid: "",
        id: "",
      },
      inpDisabled: false,
      ruleuserInfo: {
        userName: [
          { required: true, message: "姓名不能为空", trigger: "blur" },
        ],
        userIdCard: [
          { required: true, message: "身份证号不能为空", trigger: "blur" },
        ],
        userTel: [
          { required: true, message: "联系电话不能为空", trigger: "blur" },
        ],
        userAdress: [
          { 
            required: true, 
            message: "家庭地址不能为空", 
            trigger: "blur" 
          },
          {
            min: 5,
            max: 100,
            message: "地址长度必须在5-100个字符之间",
            trigger: "blur"
          }
        ],
        emergencyContactName: [
          {
            required: true,
            message: "紧急联系人姓名不能为空",
            trigger: "blur"
          },
          {
            min: 2,
            max: 20,
            message: "紧急联系人姓名长度必须在2-20个字符之间",
            trigger: "blur"
          }
        ],
        emergencyContactPhone: [
          {
            required: true,
            message: "紧急联系人电话不能为空",
            trigger: "blur"
          },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的11位手机号码",
            trigger: "blur"
          }
        ],
      },
    };
  },
  methods: {
    getUserInfo() {
      var _this = this;
      _this.$http
        .get("retire-school-manage/personal/getMyInfo", {
          params: {
            // studentId: 555 // 学员id
            studentId: _this.$store.state.studentId,
          },
        })
        .then((res) => {
          if (res.data.status == 2000) {
            _this.userInfoForm.userIdCard = res.data.data.idCard;
            _this.userInfoForm.userName = res.data.data.name;
            _this.userInfoForm.userSex = res.data.data.sex;
            _this.userInfoForm.userEdcation = res.data.data.education;
            _this.userInfoForm.userUnit = res.data.data.workUnit;
            _this.userInfoForm.userTel = res.data.data.phone;
            _this.userInfoForm.userEmail = res.data.data.email;
            _this.userInfoForm.userAdress = res.data.data.address;
            _this.userInfoForm.emergencyContactName = res.data.data.emergencyContactName;
            _this.userInfoForm.emergencyContactPhone = res.data.data.emergencyContactPhone;
            _this.userInfoForm.userStatus = res.data.data.studentType;
            _this.userInfoForm.id = res.data.data.id;
            _this.userInfoForm.sid = res.data.data.sid;

            if (res.data.data.payEndDate != null) {
              _this.inpDisabled = true;
            }
          } else {
            console.log("数据获取失败");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updataSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          var _this = this;
          _this.$http
            .post("retire-school-manage/personal/updateMyInfo", {
              idCard: _this.userInfoForm.userIdCard,
              name: _this.userInfoForm.userName,
              sex: _this.userInfoForm.userSex,
              education: _this.userInfoForm.userEdcation,
              workUnit: _this.userInfoForm.userUnit,
              phone: _this.userInfoForm.userTel,
              email: _this.userInfoForm.userEmail,
              studentType: _this.userInfoForm.userStatus,
              address: _this.userInfoForm.userAdress,
              emergencyContactName: _this.userInfoForm.emergencyContactName,
              emergencyContactPhone: _this.userInfoForm.emergencyContactPhone,
              id: _this.userInfoForm.id,
              sid: _this.userInfoForm.sid,
              lastUpdateUser: _this.userInfoForm.sid,
            })
            .then((res) => {
              if (res.data.status == 2000) {
                this.$Message.success("更新成功!");
              }
            });
        } else {
          this.$CustomMessageError("Fail!");
        }
      });
    },
  },
  mounted() {
    this.getUserInfo();
  },
};
</script>

<style scoped>
.userContent {
  height: calc(100vh - 185px - 57px);
  width: 1200px;
  margin: 0 auto;
  padding: 30px;
  box-sizing: border-box;
  overflow-y: auto;
  background: #fff;
}

.userContent /deep/ form {
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
}

.userContent /deep/ .ivu-form-inline .ivu-form-item {
  width: 45%;
  margin-right: 5%;
  margin-bottom: 25px;
}

.userContent /deep/ .ivu-input,
.userContent /deep/ .ivu-select {
  width: 280px;
}

.userContent /deep/ .ivu-form-item-label {
  color: #666;
  font-size: 14px;
}

.btn {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 40px;
}

.btn .upData {
  width: 180px;
  height: 40px;
  font-size: 16px;
  border-radius: 4px;
}

@media screen and (max-width: 768px) {
  .userContent {
    width: 100%;
    height: 1200px;
    overflow-y: auto;
    padding: 0 16px;
  }

  .userContent /deep/ form {
    margin-top: 16px;
  }

  .userContent /deep/ .ivu-form-inline .ivu-form-item {
    margin-right: 0;
    width: 100%;
    margin-bottom: 20px;
  }

  .userContent /deep/ .ivu-form-item-label {
    text-align: left;
    padding: 0 0 10px 0;
    font-size: 16px;
    color: #333;
    line-height: 1.5;
    font-weight: 500;
    float: none !important;
  }

  .userContent /deep/ .ivu-input[disabled] {
    color: #666;
    background-color: #f5f5f5;
  }

  .userContent /deep/ .ivu-form-item-error-tip {
    font-size: 13px;
    padding-top: 4px;
  }

  .btn {
    margin-top: 30px;
  }

  .btn .upData {
    width: 100%;
    margin: 0;
    height: 46px;
    font-size: 16px;
    border-radius: 6px;
  }

  .btn /deep/ {
    justify-content: center;
    padding: 0 16px;
  }

  /* 调整表单项标签宽度 */
  .userContent /deep/ .ivu-form-item-label {
    width: auto !important;
  }

  /* 调整表单项内容区域 */
  .userContent /deep/ .ivu-form-item-content {
    margin-left: 0 !important;
  }
}
</style>